module.exports = __webpack_public_path__ + "static/media/hargreaves.d71892ed.svg";